var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56657_12075)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56657_12075",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56657_12075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.0001C15.0417 23.0001 14.6493 22.8369 14.3229 22.5105C13.9965 22.1841 13.8333 21.7917 13.8333 21.3334V11.3334C13.8333 10.8751 13.9965 10.4827 14.3229 10.1563C14.6493 9.82994 15.0417 9.66675 15.5 9.66675H23C23.4583 9.66675 23.8507 9.82994 24.1771 10.1563C24.5035 10.4827 24.6667 10.8751 24.6667 11.3334V21.3334C24.6667 21.7917 24.5035 22.1841 24.1771 22.5105C23.8507 22.8369 23.4583 23.0001 23 23.0001H15.5ZM15.5 21.3334H23V11.3334H15.5V21.3334ZM12.1667 26.3334C11.7083 26.3334 11.316 26.1702 10.9896 25.8438C10.6632 25.5174 10.5 25.1251 10.5 24.6667V13.0001H12.1667V24.6667H21.3333V26.3334H12.1667Z",
    fill: "#5F5C71"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56657_12075"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.266f29c540259875f99222259ad1103d.svg";
export { ForwardRef as ReactComponent };